
import { mapGetters } from 'vuex'
import { RestrictMallCode } from '@/enum/localEnum'
const SellGoodsTypeModel = () => import('@/components/CSS/SellGoodsTypeModel')
const ReleaseSteps = () => import('@/components/release/ReleaseSteps')

import { setHistoryList } from '~/utils/validate'
export default {
    name: 'appHeader',
    components: {
        SellGoodsTypeModel,
        ReleaseSteps
    },
    props: {
        gameChangeData: {}
    },
    // serverCacheKey: (props) => props.tempId,
    data() {
        return {
            buyType: '',
            value: '',
            showUserInfoBox: false,
            active: null,
            searchData: {
                gameName: null,
                keyReason: null,
                gameId: null,
                goodsType: null,
                district: null,
                server: null
            },
            navList: [
                {
                    path: '/',
                    name: '首页',
                    trackType: 'ENTER_HOMEPAGE'
                },
                {
                    path: `/gameList`,
                    name: '我要买',
                    topHeader: '6',
                    trackType: 'HOMEPAGE_BUY',
                    hot: true
                },
                {
                    name: '我要卖',
                    trackType: 'HOMEPAGE_SELL',
                    type: 'sell',
                    hot: true
                },
                {
                    path: '/Intermediary',
                    name: '中介担保',
                    trackType: 'HOMEPAGE_PROXY_GUARANTEE'
                },
                {
                    name: '估值回收',
                    type: 'recovery'
                },
                {
                    path: '/business',
                    name: '业务介绍'
                },
                {
                    path: '/helpCenter',
                    name: '帮助中心',
                    trackType: 'HOMEPAGE_HELP_CENTER'
                },
                {
                    path: '/gameInformation',
                    name: '游戏资讯'
                },
                {
                    path: '/account',
                    name: '个人中心',
                    trackType: 'HOMEPAGE_MINE'
                }
            ],
            stepNumber: null,
            goodsTypeList: [],
            gameDistrict: [],
            activeNav: null,
            showGameSearch: false,
            currentRouteName: null // 当前路由名称
        }
    },

	computed: {
		...mapGetters({
			token: 'user/token',
			userinfo: 'user/userinfo',
			gameList: 'game/gameList',
			gameHotList: 'game/gameHotList',
			gameGoodsTypeList: 'game/gameGoodsTypeList'
		}),
		// 获取前6个热门游戏
		gameHotData() {
			return [...this.gameHotList].splice(0, 6)
		}
	},
	created() {
		if (process.client) {
            // 初始化当前路由名称
			if (this.$route.meta.belongGroup !== 'login' && this.$route.path !== '/download' && this.$route.path !== '/downloadPc') {
				this.$store.dispatch('game/GameList')
			}
		}
	},
	watch: {
		$route: {
            handler(route) {
                this.currentRouteName = route.name
                switch (route.name) {
                    case 'home':
                        this.activeNav = '/'
                        break
                    case 'gameList':
                    case 'goodsList':
                    case 'goodsDetails':
                        this.activeNav = '/gameList'
                        break
                    case 'Intermediary':
                        this.activeNav = '/Intermediary'
                        break
                    case 'business':
                        this.activeNav = '/business'
                        break
                    case 'helpCenter':
                    case 'advise':
                    case 'services':
                    case 'servicesList':
                        this.activeNav = '/helpCenter'
                        break
                    case 'gameInformation':
                    case 'articleDetails':
                        this.activeNav = '/gameInformation'
                        break
                    case 'accountHome':
                        this.activeNav = '/account'
                        break
                    case 'download':
                        this.activeNav = '/download'
                        break
                    default:
                        break
                }
                this.active = route.meta.belongGroupPath || route.path
                if (route.name == 'home') {
                    this.searchData.gameName = null
                    this.searchData.keyReason = null
                    this.searchData.gameId = null
                }
                if (route.query.buyType) {
                    this.buyType = this.$route.query.buyType
                } else {
                    this.buyType = ''
                }
                if (!Object.keys(route.params).length) return
                // 搜索框选中值
                if (route.params.gameId) {
                    this.searchData.gameId = parseInt(route.params.gameId)
                    this.gameList.map(item => {
                        if (this.searchData.gameId == item.id) {
                            this.searchData.gameName = item.name
                        }
                    })
                    // this.onChangeGameTypeById(route.params.gameId);
                } else {
                    this.searchData.gameId = null
                    this.searchData.goodsType = null
                }
                if (route.params.keyReason) {
                    this.searchData.keyReason = route.params.keyReason
                }
                if (route.params.goodsCatalogueId) {
                    this.searchData.goodsType = parseInt(route.params.goodsCatalogueId)
                }
            },
            immediate: true
        },
		gameChangeData(val) {
			this.searchData.gameName = val.name
			this.searchData.gameId = val.id
		}
	},
    methods: {
        gotoDownload() {
            window, open('/download', '_blank')
        },
        handleClick(type = 'sell') {
            switch (type) {
                case 'sell':
                this.$trackEvent({
                    eventType: 'click',
                    trackParams: {
                        eventName: '我要卖'
                    }
                })
                case 'recovery':
                    // 需要登录
                    if (!this.token) {
                        this.$message.warning('请先登录')
                        this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
                        return
                    }

                    // 检查是否被限制售卖商品
                    const isRestrict = this.$store?.getters?.['user/checkUserRestrictMall'](RestrictMallCode.GOODS_SELL)
                    if (isRestrict) {
                        return
                    }
                    this.handleSell(type)
                    break
            }
        },
        // 我要卖
        handleSell(type) {
            this.$nextTick(() => {
                // this.$refs.typeModel.tabActiveKey = type
                this.$refs.typeModel.dialogVisible = true
                window._czc && window._czc.push(['_trackEvent', '访问量', '我要卖页面'])
            })
        },
        /**
         * 获取select的label值
         */
        getGameOption(val) {
            let obj = {}
            obj = this.gameList.find(item => {
                return item.id === val
            })
            if (!obj) return
            this.searchData.gameName = obj.name
        },

        /**
         * 点击单个游戏item
         */
        onGetSearchGame(val) {
            this.onChangeGameTypeById(val.id)
            this.searchData.gameId = val.id
            this.searchData.gameName = val.name || '' // 确保游戏名称更新

            // 移除焦点
            this.$nextTick(() => {
                document.activeElement.blur() // 让当前焦点元素失去焦点
            })

            // 关闭弹框
            this.showGameSearch = false

            if (['goodsList'].includes(this.$route.name)) {
                this.jumpToList()
            }
        },
        /**
         * 获取游戏类型
         */
        onChangeGameTypeById(v) {
            this.clearSearchValue('game')
            const p = {
                action: {
                    gameId: v
                }
            }
            this.getGameOption(v)

            this.$api.listGoodsCatalogueBySearch(p).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                // 暂时未知功能
                // this.$store.commit('game/SET_ORDER_FLOW_SHOW', res.data)
                // this.$store.commit('ry/SET_ORDER_FLOW_SHOW', res.data)
                this.goodsTypeList = res.data
            })
        },
        /**
         * 获取游戏大区
         * 已砍掉
         */
        onChangeGameDistrictByType(v) {
            this.clearSearchValue('goodsType')
            const p = {
                action: {
                    gameId: this.searchData.gameId,
                    goodsCatalogueId: v
                }
            }
            this.$api.treeGameProperTiesBySearch(p).then(res => {
                if (!res.success) {
                    this.$message.error(res.info)
                    return
                }
                this.gameDistrict = res.data
            })
        },

        /**
         * 清除筛选结果
         */
        clearSearchValue(type) {
            switch (type) {
                case 'game':
                    this.goodsTypeList = []
                    this.gameDistrict = []
                    this.searchData.keyReason = null
                    this.searchData.goodsType = null
                    this.searchData.district = null
                    this.searchData.server = null
                    break
                case 'goodsType':
                    this.gameDistrict = []
                    this.searchData.district = null
                    this.searchData.server = null
                    break
                case 'dist':
                    this.searchData.server = null
                    break
            }
        },
        gotoPage(item) {
            setHistoryList(item)
            this.$store.commit('game/SET_BUY_GOODS_TYPE', 6)
            window.open(`/goodsList/${item.id}/6`, '_blank')
        },
        /**
         * 跳转到游戏列表
         * 没有选中游戏类型就默认为账号
         */
        async getshibboleth() {
            return new Promise(async (resolve, reject) => {
                try {
                    if (this.searchData.keyReason !== null && this.searchData.keyReason.startsWith('#')) {
                        const { data } = await this.$api.getshibboleth({
                            shibboleth: this.searchData.keyReason
                        })
                        resolve(true)
                        if (data === null) {
                            this.$message.error('口令失效/过期')
                            return

                        }


                        if (data.jumpSubType === 'FKHD' || data.jumpSubType === 'OTHER') {
                            this.$message.error('请前往APP，或用手机打开网页搜索')
                            return
                        }
                        if (!this.userinfo?.id) {
                            this.$router.push({
                                name: "login",
                                params: {
                                    key: data?.id,
                                    path: data.jumpContent
                                }
                            })
                            this.searchData.keyReason = null
                            return
                        }
                        if (data.jumpSubType === 'GOODS_LIST') {
                            this.$router.push(`/goodsList/${data.jumpContent}/6`)


                        }



                    } else {
                        resolve(false)
                    }
                } catch (err) {
                    reject(err)
                }
            })
        },
        jumpToList() {
            if (!this.searchData.gameId) {

                this.$message.error('请先选择游戏')
                return
            }
            if (!this.searchData.goodsType) {
                // this.$message.error('请选择游戏类型')
                // return;
                this.searchData.goodsType = this.goodsTypeList?.[0]?.id || this.$enum.GOODS_TYPE.ACCOUNT
            }
            // 通过gameId获取游戏详情
            const itemGame = this.gameList.find(item => item.id === parseInt(this.searchData.gameId))

            if (itemGame && itemGame !== '{}') setHistoryList(itemGame)
            this.$store.commit('game/SET_BUY_GOODS_TYPE', this.searchData.goodsType)
            if (this.searchData.keyReason) {
                const par = {
                    action: { message: this.searchData.keyReason }
                }
                this.$api.addPublic(par)
            }
            this.$router.push({
                // path: "/goodsList",
                name: 'goodsList',
                params: {
                    gameId: this.searchData.gameId,
                    goodsCatalogueId: this.searchData.goodsType,
                    keyReason: this.searchData.keyReason ? this.searchData.keyReason : null,
                    from: 'headerSearch'
                }
            })
        },
        async gotoGameListPage() {
            const data = await this.getshibboleth()
            if (data) return
            this.jumpToList()
        },
        // ...mapActions(['GameList']),
        getGameList() {
            //
            //   this.GameList();
        },
        // 显示游戏查询列表
        searchClickShow() {
            this.$emit('clickShow')
        }
    }
}
